<template>
  <div>
    <div v-if="loading === true">
      <div class="centered">
        <a-spin />
      </div>
    </div>
    <form class="col-md-13 col-lg-6">
      <div>
        <div>
          <div class="">
            <label for="full_name" class="form-label">Name*:</label>
            <input type="text" class="form-control" v-model="user.full_name" id="full_name" />
          </div>

          <div class="row mt-3">
            <div class="col-md-6">
              <label for="phone" class="form-label">Phone*:</label>
              <input type="number" class="form-control" v-model="user.phone" id="phone" />
            </div>

            <div class="col-md-6">
              <label for="ext" class="form-label">Ext:</label>
              <input type="text" class="form-control" v-model="user.ext" id="ext" />
            </div>
          </div>

          <div class="mt-3">
            <label for="email" class="form-label">Email*:</label>
            <input type="email" class="form-control" v-model="user.email" id="email" />
          </div>

          <div class="mt-3">
            <label for="username" class="form-label">Username* (i.e. - "JDoe"):</label>
            <input type="text" class="form-control" v-model="user.username" id="username" />
          </div>

          <div class="mt-3">
            <label for="password" class="form-label">Password*:</label>
            <input type="text" class="form-control" v-model="user.password" id="password" />
          </div>

          <div class="mt-3">
            <label for="auth_num" class="form-label">Seurtiy Role*:</label>
            <b-select class="form-select" v-model.number="user.auth_num">
              <option>--Select--</option>
              <option v-for="role in this.allSecurityRoles.result" :key="role.id" :value="role.sec_id">
                {{ role.label }}
              </option>
            </b-select>
          </div>
        </div>
      </div>
    </form>
    <div class="row mt-2">
      <div style="padding-left:15px">
        <input class="btn btn-primary btn-sm-block mr-2" type="submit" name="add" value="Update" @click="onUpdate" />
        <router-link
          :to="{
            name: 'ManageUsers',
          }"
          @click.native="scrollToTop"
          class="btn btn-danger text-white btn-sm-block mr-2"
          type="button"
          >Cancel</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditUsersForm',
  data() {
    return {
      loading: false,
      userId: this.$route.params.Id,
    };
  },
  computed: {
    user() {
      return this.$store.state.manageSystemUsers.user;
    },
    allSecurityRoles() {
      return this.$store.getters['manageSystemUsers/allSecurityRoles'];
    },
  },
  methods: {
    onUpdate(e) {
      e.preventDefault();
      if (this.user.full_name == '') {
        alert('Please enter a name');
        return;
      }

      if (this.user.phone == '') {
        alert('Please enter a phone number');
        return;
      }

      if (this.user.email == '') {
        alert('Please enter an email address');
        return;
      }

      if (this.user.username == '') {
        alert('Please enter a username');
        return;
      }

      if (this.user.password == '') {
        alert('Please enter a password');
        return;
      }

      if (this.user.auth_num == '') {
        alert('Please select a role');
        return;
      }

      // compare password checks
      if (this.user.password == 'password' || this.user.password.length < 5 || this.user.password === this.user.username) {
        this.$store.commit('manageSystemUsers/SET_PASSWORD_CHECK', true);
        this.$router.push({
          name: 'ManageUsers',
        });
        return;
      }

      // api call
      this.$store.dispatch('manageSystemUsers/updateSystemUser', this.user).then((resp) => {
        console.log(resp.status);
        if (resp.status === 200) {
          this.$router
            .push({
              name: 'ManageUsers',
              params: {
                success: true,
                action: 'The user has been updated.',
              },
            })
            .then(() => {
              window.scrollTo(0, 0);
            });
        } else {
          alert(resp.data.message);
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch('manageSystemUsers/fetchAllSecurityRoles', {
      pg_num: 1,
      pg_size: 100,
      searchterm: '',
    });
  },
  created() {
    window.scrollTo(0, 0);
    this.loading = true;
    if (this.$route.params.Id) {
      this.$store
        .dispatch('manageSystemUsers/fetchSystemUserById', {
          userId: this.userId,
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
};
</script>
<style scoped>
form {
  border: 1px solid #ccc;
  padding: 20px;

  border-radius: 5px;
}

form label {
  font-size: 15px;
  font-weight: bold;
}

.form-label,
.form-check-label {
  margin-top: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
}

.form-check {
  padding-left: 2rem !important;
}

.centered {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
  color: darkred;
  z-index: 99999;
}
</style>
